import { Controller } from "stimulus"
import { FormClient } from "../helpers/form_client"
import { showTarget, hideTarget } from "../helpers/visibility"

export default class extends Controller {
  static targets = ["checkbox", "amount", "submitButton"]
  static values = { billId: String }

  connect() {
    this.updateAmountVisibility()
  }

  disconnect() {
    // Clean up when controller is removed
  }

  async submitForm() {
    // Update amount field visibility based on checkbox state
    this.updateAmountVisibility()

    // If checking a line, also check all other lines in the same bill
    // If unchecking a line, also uncheck all other lines in the same bill
    if (this.checkboxTarget.checked) {
      this.checkAllLinesInBill()
    } else {
      this.uncheckAllLinesInBill()
    }

    // Submit form using the reusable FormClient
    try {
      await FormClient.submitFormIn(this.element)
    } catch (error) {
      alert("Error updating authorization. Please try again.")
    }
  }

  showSubmitButton() {
    showTarget(this.submitButtonTarget)
  }

  updateAmountVisibility() {
    if (this.hasAmountTarget) {
      if (this.checkboxTarget.checked) {
        showTarget(this.amountTarget)
      } else {
        hideTarget(this.amountTarget)
      }
    }
  }

  checkAllLinesInBill() {
    // Find all other controllers for the same bill ID
    const billId = this.billIdValue
    const otherControllers = document.querySelectorAll(`[data-controller="unpaid-bill-line"][data-unpaid-bill-line-bill-id-value="${billId}"]`)

    otherControllers.forEach(controllerElement => {
      if (controllerElement === this.element) return // Skip current element

      const checkbox = controllerElement.querySelector('[data-unpaid-bill-line-target="checkbox"]')
      const amountField = controllerElement.querySelector('[data-unpaid-bill-line-target="amount"]')

      if (checkbox && !checkbox.checked) {
        // Check the checkbox
        checkbox.checked = true

        // Show the amount field
        if (amountField) {
          showTarget(amountField)
        }

        // Submit the form for this line
        const form = controllerElement.querySelector('form')
        if (form) {
          FormClient.submit(form).catch(error => {
            console.error("Error auto-checking line:", error)
          })
        }
      }
    })
  }

  uncheckAllLinesInBill() {
    // Find all other controllers for the same bill ID
    const billId = this.billIdValue
    const otherControllers = document.querySelectorAll(`[data-controller="unpaid-bill-line"][data-unpaid-bill-line-bill-id-value="${billId}"]`)

    otherControllers.forEach(controllerElement => {
      if (controllerElement === this.element) return // Skip current element

      const checkbox = controllerElement.querySelector('[data-unpaid-bill-line-target="checkbox"]')
      const amountField = controllerElement.querySelector('[data-unpaid-bill-line-target="amount"]')

      if (checkbox && checkbox.checked) {
        // Uncheck the checkbox
        checkbox.checked = false

        // Hide the amount field
        if (amountField) {
          hideTarget(amountField)
        }

        // Submit the form for this line
        const form = controllerElement.querySelector('form')
        if (form) {
          FormClient.submit(form).catch(error => {
            console.error("Error auto-unchecking line:", error)
          })
        }
      }
    })
  }

}
